import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';



function contact() {
    if ($('[data-element="contact_box"]').length) {
        const mediaQuery = window.matchMedia('(min-width: 1024px)');
        if (mediaQuery.matches) {
            const maxcontactheight = $(window).height() - $("[data-element='contact_wrap'").offset().top;
            $("[data-element='contact_box'").css('max-height', maxcontactheight - 40)
        }
    }

   
}

export default contact;